import React from 'react';
import './index.scss';

const PcInputTitleMessage = ({ title, message, children }) =>{
  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  return (
    <div className="PcInputTitleMessage">
      <div className="PITM-title"> 
        <DispTitle />
        <div className="attention">
          {message}
        </div>
      </div>
      <span className="PITM-item">
        {children}
      </span>
    </div>
  );
};

export default PcInputTitleMessage;